// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__ICW5Z","tooltip":"Avatar_tooltip__d4CTl"};